import { when } from 'mobx';
export class FetchPackages {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get packages() {
        return this.parent;
    }
    get Edit() {
        return when(() => !!this.packages.streamedPackages.Edit);
    }
    get Defer() {
        return when(() => !!this.packages.streamedPackages.Defer);
    }
    get Lazy() {
        return when(() => !!this.packages.streamedPackages.Lazy);
    }
    get Large() {
        return when(() => !!this.packages.streamedPackages.Large);
    }
    get Mobile() {
        return when(() => !!this.packages.streamedPackages.Mobile);
    }
    get Exotic() {
        return when(() => !!this.packages.streamedPackages.Exotic);
    }
    get Multi() {
        return when(() => !!this.packages.streamedPackages.Multi);
    }
    get Abfrager() {
        return when(() => !!this.packages.streamedPackages.Abfrager);
    }
    get Draft() {
        return when(() => !!this.packages.streamedPackages.Draft);
    }
}
